import moment from "moment"
import { useEffect, useState } from "react"
import CountdownComponentSimple from "../CountdownComponentSimple"

export default function CircleCountDown({items, onCompleteTimeStart}){
    const [startMeeting, setStartMeeting] = useState(null)
    const [serverTime, setServerTime] = useState(null)
    const [clientTime, setClientTime] = useState(null)
    const [styleCountdown, setStyleCountdown] = useState({
        animation: 'countdown 100s linear infinite forwards'
    })

    useEffect(()=>{
        setClientTime(Date.now())        
        setServerTime(moment(items.cita.currentTime, "DD/MM/YYYY HH:mm:ss").valueOf())
        setStartMeeting(moment(items.cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").valueOf())
        //calcular segundos de dif
        const diffSec = moment(items.cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
                        .diff(moment(items.cita.currentTime, "DD/MM/YYYY HH:mm:ss"), 'seconds')
        setStyleCountdown({
            animation: `countdown ${diffSec}s linear infinite forwards`
        })
    }, [])

    return (
        <div id="countdown">
            <div id="countdown-number">
            {
                startMeeting &&
                <CountdownComponentSimple 
                    date={startMeeting} 
                    serverTime={serverTime}
                    setServerTime={setServerTime}
                    clientTime={clientTime}
                    setClientTime={setClientTime}
                    onComplete={onCompleteTimeStart}
                />
            }
            </div>
            <svg>
                <circle r="40" cx="50" cy="50" style={styleCountdown}></circle>
            </svg>
        </div>
    )
}